import {GET_TASK_LIST_FEATURES_KEY} from "web-library/constants/queryKeys";
import {GET_TASK_LIST_FEATURES_URL} from "web-library/constants/apiUrls";
import {TaskListFeatures} from "web-library/models/Request"
import axiosClient from "../axiosClient";
import {useCustomQuery} from '../utils/useCustomQuery';

export const useGetTaskListFeatures = () => {
  const getTaskListFeatures = async () => {
    const res = await axiosClient.get<TaskListFeatures>(GET_TASK_LIST_FEATURES_URL);

    return res.data;
  }

  return useCustomQuery(GET_TASK_LIST_FEATURES_KEY, getTaskListFeatures);
}